var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Doctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 62H15V46.77A6.999 6.999 0 0122.23 40h3.31a16.37 16.37 0 00-2.72 6 2.5 2.5 0 103.45 2.31 2.53 2.53 0 00-.54-1.54C26.14 45 27.26 41.64 30 40h15.08c2.48 1.5 3.64 4.49 4.12 6.29a7 7 0 00-5.3 7v4.75H48V55h-1v-1.72a3.93 3.93 0 014-4.21 4 4 0 014 4.18v1.68L54 55v3h4.12v-4.72a7 7 0 00-5.78-7.08A16.37 16.37 0 0049.5 40h4.23A7.15 7.15 0 0161 47v15zM44.47 33.37a10.38 10.38 0 10-14.59-1.65 10.39 10.39 0 0014.59 1.65z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Doctor.8bc82a6d.svg";
export { SvgK1Doctor as ReactComponent };